import StyleParamsClientWithSDK from '../lib/settings/styleParamsClient/StyleParamsClientWithSDK';
import SettingsClient from '../lib/settings/SettingsClient/SettingsClient';

const styleParamsClient = new StyleParamsClientWithSDK();
const settingsClient = new SettingsClient(styleParamsClient, {
  logger: console,
});

export default settingsClient;
